import { Injectable } from '@angular/core';
import { ApiServiceProvider } from '../api-service/api-service';

@Injectable()
export class InterestsServiceProvider {
  constructor(public apiService: ApiServiceProvider) {}

  getInterests() {
    return this.apiService.get(`/interests`);
  }

  getInterestsByUser(profileId: string) {
    return this.apiService.get(`/profile/${profileId}/interests`);
  }

  addInterests(profileId: string, interests) {
    return this.apiService.post(`/profile/${profileId}/interests`, interests);
  }

  deleteInterestsByUser(profileId: string, interestId: string) {
    return this.apiService.delete(
      `/profile/${profileId}/interests/${interestId}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/interests-service/interests-service.ts